export default "__VITE_ASSET__CedkzVkE__"